import React from 'react';
import { TextField } from '@material-ui/core';

class ManualInput extends React.Component {
    state = {
        value: undefined,
    };

    handleChange = e => {
        this.setState({ value: e.target.value });
    };

    render() {
        const { onBlur, onFocus, onBarCodeRead } = this.props;
        return (
            <form noValidate autoComplete="off" onSubmit={e => {
                e.preventDefault();
                onBarCodeRead(this.state.value);
            }}>
                <TextField
                    id="outlined-name"
                    label={this.props.label}
                    //className={classes.textField}
                    value={this.state.value}
                    margin="normal"
                    variant="outlined"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={this.handleChange}
                />
            </form>
        );
    }
}

export default ManualInput;